'use strict';
var parent = require('../../es/array/to-reversed');

module.exports = parent;
